import React from 'react'
import styled from 'styled-components'
import { useIntl } from 'react-intl'
import { CardBody } from 'reactstrap'

import { LoadableCard } from '~/components/commons'
import LocationIcon from 'assets/img/svg/location-icon.svg'
import ShopIcon from 'assets/img/svg/shop-icon.svg'
import ClockIcon from 'assets/img/svg/clock-icon.svg'
import ClosedIcon from 'assets/img/svg/closed-icon.svg'

export const LocationOverviewGrid = ({ data, loading }) => {
  return (
    <GridContainer>
      <LocationCard
        count={data?.count}
        title="Locations"
        color="#8176F1"
        icon={LocationIcon}
        loading={loading}
      />
      <LocationCard
        count={data?.open}
        title="Open"
        color="#38A169"
        icon={ShopIcon}
        loading={loading}
      />
      <LocationCard
        count={data?.tempClosed}
        title="Temporarily Closed"
        color="#F6AD55"
        icon={ClockIcon}
        loading={loading}
      />
      <LocationCard
        count={data?.closed}
        title="Closed"
        color="#C53030"
        icon={ClosedIcon}
        loading={loading}
      />
    </GridContainer>
  )
}

export const LocationCard = ({ count, title, color, icon, loading }) => {
  const intl = useIntl()

  return (
    <LoadableCard loading={loading}>
      <CardBody>
        <FlexContainer>
          <div>
            <h2>{count ?? 0}</h2>
            <span>{intl.formatMessage({ id: title })}</span>
          </div>
          <div style={{ marginLeft: '1em' }}>
            <div className="location-icon" style={{ backgroundColor: color }}>
              <img src={icon} width="40px" alt="" />
            </div>
          </div>
        </FlexContainer>
      </CardBody>
    </LoadableCard>
  )
}

const GridContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.5em;

  .card {
    margin-bottom: 1em;
  }
`

const FlexContainer = styled.div`
  height: 5em;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    font-size: 36px;
    font-weight: 700;
  }

  span {
    font-size: 14px;
    font-weight: 400;
    color: #4a5568;
  }

  .location-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 4em;
    height: 4em;
    aspect-ratio: 1/1;
    padding: 1em;
    border-radius: 10px;
  }
`
